/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-03-15 09:36:02
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-14 16:08:28
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/basics/mobileUnit/QueryPage'
export const batchUpdateOrDelete = '/icps/system/basics/mobileUnit/deletes'
export const saveOrUpdate = '/icps/system/basics/mobileUnit/save_or_update'
export const updateSortNum = '/icps/system/basics/mobileUnit/update_sort_num'
export function queryDetailByid(data) {
  return request({
    url: '/icps/system/basics/mobileUnit/queryDetailByid',
    method: 'post',
    data
  })
}
export function QueryListByCompanyId(data) {
  return request({
    url: '/icps/system/sign/basics/car/QueryListByCompanyId',
    method: 'post',
    data
  })
}